<template>
<div>
    <v-text-field
        :label="label"
        :value="value_text"
        disabled
        v-if="!dialog_only"
        autocomplete="off"
    >
        
        <span
            slot="append-outer"
            v-if="!read_only"
        >
             <m-edit-menu
                :menu_items="menu_items"
                v-on:menu-action="onMenuAction($event)"
             />
        </span>

    </v-text-field>

    <m-mobile-autocomplete-dialog
        ref="search-dialog"
        :search="search"
        :items="items"
        :placeholder="placeholder"
        v-on:input="onInput($event)"
        v-on:remove="onRemove($event)"
        v-on:toggle-multiselect="toggleMultiselect"
        v-on:begin-conversation="onBeginConversation"
        :is_multiselect="is_multiselect"
        :selected_values="selected_values"
        :disable_group_text="disable_group_text"
        :action_button_text="action_button_text"
        :default_multiselect="default_multiselect"
        :optional="optional"
    >
        <template v-slot:default="slotProps">
            <slot v-bind:item="slotProps.item">
                <v-list-item-content>{{slotProps.item.text}}</v-list-item-content>
            </slot>
        </template>
    </m-mobile-autocomplete-dialog>
</div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: function() { return "Input"; }
        },

        placeholder: {
            type: String,
            default: function() { return "Search"; }
        },

        value: {
            type: [Object, String],
            default: function() { return null; }
        },

        menu_items: {
            type: Array,
            default: function() { return []; }
        },

        search: {
            type: Function,
            default: function() { return () => { return []; } }
        },

        items: {
            type: Array,
            default: function() { return []; },
        },

        dialog_only: {
            type: Boolean,
            default: function() { return false; },
        },

        is_multiselect: {
            type: Boolean,
            default: function() { return false; }
        },

        disable_group_text: {
            type: Boolean,
            default: function() { return false; }
        },

        selected_values: {
            type: Array,
            default: function() { return []; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },

        action_button_text: {
            type: String,
            default: function() { return 'Begin Conversation'; }
        },

        default_multiselect: {
            type: Boolean,
            default: function() { return false; }
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    methods: {
       toggleMultiselect()
       {
           this.$emit('toggle-multiselect');
       },

       onMenuAction()
       {
           this.$refs['search-dialog'].showDialog();
       },

       onInput(item)
       {
           this.$emit('input',item);
       },

       onRemove(item)
       {
           this.$emit('remove',item);
       },

       showDialog()
       {
            this.$refs['search-dialog'].showDialog();
       },

        onBeginConversation()
        {
            this.$emit('begin-conversation');
        },
    },

    computed: {
        value_text() {
            if ( this.value == null ) return null;
            return this.value.text;
        }
    },
    
}
</script>

<style lang="scss" scoped>

</style>